import React from 'react';
export const SyncLogs = ({ logs }) => {
    if (!(logs === null || logs === void 0 ? void 0 : logs.length)) {
        return null;
    }
    return (React.createElement(React.Fragment, null, logs.map((log) => React.createElement("pre", { key: log.text }, log.text))));
};
